export const ATTEMPT_LOGIN = 'ATTEMPT_LOGIN';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT = 'LOGOUT';